<div class="index-shell">
    <app-header [breadcrumbs]="['Clients']" mainHeading="Clients" [links]="['/clients']">
        <div headingButton>
            <button class="add-button" cll-icon-button (click)="navigateToAddClient()">
                <cll-icon type="outlined">add</cll-icon>
            </button>
        </div>
    </app-header>

    <div>
        <cll-horizontal-tabs
            [appearance]="'contained'"
            [tabItems]="tabItems"
            [currentTabId]="(currentTabId$ | async)!"
            (currentTabIdChange)="currentTabIdChange($event)" />
        <div class="client_filter">
            <cll-form-field label="Type a keyword..." class="client_search">
                <cll-icon cllPrefix>search</cll-icon>
                <input [formControl]="searchControl"
                       cllFormInput
                       type="text">

                @if (searchControl.value) {
                    <button (click)="searchControl.reset()"
                            cll-icon-button
                            cllTooltip="Clear search query"
                            cllSuffix>
                        <cll-icon>clear</cll-icon>
                    </button>
                }
            </cll-form-field>
            <div class="client_view_type">
                <span>View: </span>
                <cll-chip-collection>
                    <cll-filter-chip colour="secondary" [selected]="listType() === 'list'"
                                     [disabled]="listType() === 'list'"
                                     (click)="updateListType('list')">List
                    </cll-filter-chip>
                    <cll-filter-chip colour="secondary" [selected]="listType() === 'map'"
                                     [disabled]="listType() === 'map'"
                                     (click)="updateListType('map')">Map
                    </cll-filter-chip>
                </cll-chip-collection>

            </div>
        </div>
        @if (listType() === 'list') {
            @if (pageResult(); as request) {
                @if (request.isLoading) {
                    <cll-spinner />
                }

                @if (request.error; as error) {
                    <app-error-panel [error]="error" />
                }

                @if (request.value; as page) {

                    <table class="cll-table">
                        <colgroup>
                            <col style="width: 48px;">
                        </colgroup>

                        <thead>
                        <tr>
                            <th>Reference</th>
                            <th>Client name</th>
                            <th>Address</th>
                            <th>Phone number</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                        </thead>

                        <tbody>
                            @if (page.data.length === 0) {
                                <tr>
                                    <td colspan="6" class="no-data-row">
                                      <div class="no-data-wrapper">
                                        No Clients found.
                                      </div>
                                    </td>
                                  </tr>
                              } @else {
                            @for (client of page.data; track client.id) {
                                <tr [routerLink]="['/clients', client.id]"
                                    class="clickable">
                                    <td>{{ client.reference }}</td>
                                    <td>{{ getDisplayName(client.person) }}</td>
                                    <td>{{ client.person.address.street_1 + ', ' + client.person.address.post_code }}</td>
                                    <td>
                                        @if (client.contact_numbers[0]) {
                                            {{ client.contact_numbers[0].number }}
                                        }
                                    </td>
                                    <td>
                                        @if (client.status) {
                                            <cll-badge colour="success">Active</cll-badge>
                                        } @else {
                                            <cll-badge colour="error">Inactive</cll-badge>
                                        }
                                    </td>
                                    <td class="align-right">
                                        <button cll-icon-button
                                                [cllMenuTriggerFor]="menu"
                                                (click)="$event.stopPropagation()">
                                            <cll-icon>more_vert</cll-icon>
                                        </button>

                                        <ng-template #menu>
                                            <cll-menu>
                                                <a cllMenuItem
                                                   [routerLink]="['/clients', client.id]">
                                                    <cll-icon>open_in_new</cll-icon>
                                                    View client
                                                </a>
                                                @if (currentUser()?.permissions?.permission_name?.includes('Administrator')) {
                                                    @if (client.status) {
                                                        <button cllMenuItem
                                                                (click)="changeStatus(client, false)">
                                                            <cll-icon type="outlined">toggle_off</cll-icon>
                                                            Mark as inactive
                                                        </button>
                                                    } @else {
                                                        <button cllMenuItem
                                                                (click)="changeStatus(client, true)">
                                                            <cll-icon type="outlined">toggle_on</cll-icon>
                                                            Mark as active
                                                        </button>
                                                    }
                                                }
                                            </cll-menu>
                                        </ng-template>
                                    </td>
                                </tr>
                            }
                        }
                        </tbody>

                    </table>
                }
            }
        }

        @if (listType() === 'map') {
            @if (pagePinsResult(); as request) {
                @if (request.isLoading) {
                    <cll-spinner />
                }

                @if (request.error; as error) {
                    <app-error-panel [error]="error" />
                }

                @if (request.isSuccess()) {
                    <div class="map-list" title="map showing {{markers().length}} client locations">
                        @if (mapError()) {
                            <cll-panel colour="error">
                                <cll-icon cllPanelIcon>error</cll-icon>
                                Failed to load map. Please try again later.
                            </cll-panel>
                        }
                        <google-map [options]="options"
                                    (mapInitialized)="initMap($event)"
                                    width="100%"
                                    (error)="handleMapError($event)"
                                    (mapDragend)="onDrag()"
                                    (zoomChanged)="onZoomChange()" />
                        @if (selectedClientId() !== null) {
                            <div class="map-client-details">
                                <cll-card>
                                    <cll-card-header>
                                        <cll-icon cllCardIcon>person</cll-icon>
                                        <cll-card-title>Client details</cll-card-title>
                                        <cll-card-header-actions>
                                            <button cll-icon-button (click)="editSelectedClient()">
                                                <cll-icon type="outlined">edit</cll-icon>
                                            </button>
                                        </cll-card-header-actions>
                                    </cll-card-header>
                                    <div class="tabs-container-map" style="max-width:340px">
                                        @if (selectedClientIds()?.length ?? 0 > 1) {
                                            <cll-horizontal-tabs
                                                [appearance]="'line'"
                                                [accentColour]="'secondary'"
                                                [tabItems]="clientTabItems()"
                                                [currentTabId]="selectedClientId()??'1'"
                                                (currentTabIdChange)="currentClientTabIdChange($event)"
                                                class="map-card-tabs" />
                                        }
                                        <div class="accordion-container">
                                            <div class="map-row-field">
                                                <span class="accordion-row-label">Name</span>
                                                <span class="accordion-row-data">
                                                    @if (selectedClient()?.person) {
                                                        {{ selectedClient()?.person | personName }}
                                                    }
                                                    </span>
                                            </div>
                                            <div class="map-row-field">
                                                <span class="accordion-row-label">Reference</span>
                                                <span class="accordion-row-data">
                                                        {{ selectedClient()?.reference ?? 'N/A' }}
                                                    </span>
                                            </div>
                                            @if(selectedClient(); as selectedClient) {

                                                <div class="map-row-field">
                                                    <span class="accordion-row-label">Address</span>
                                                    <span class="accordion-row-data">
                                                        {{ getFormattedAddress(selectedClient) }}
                                                    </span>
                                                </div>

                                                @if (selectedClient.contact_numbers!.length === 0 || selectedClient.contact_numbers[0].number === '') {
                                                    <div class="map-row-field">
                                                        <span class="accordion-row-label">Phone</span>
                                                        <span
                                                            class="accordion-row-data">
                                                            Not recorded
                                                        </span>
                                                    </div>
                                                }
                                                @else {
                                                    <div class="map-row-field">
                                                        <span class="accordion-row-label">Phone</span>
                                                        <span
                                                            class="accordion-row-data">
                                                            {{ selectedClient.contact_numbers[0].number }}
                                                        </span>
                                                    </div>
                                                }
                                            }
                                        </div>
                                    </div>
                                </cll-card>
                            </div>
                        }
                    </div>
                }
            }
        }
    </div>
    <app-pagination-card
        (page)="setPage($event)"
        [meta]="meta()"
    />
</div>
